import { render } from "./local_bubble_panel.vue?vue&type=template&id=d5c59726"
import script from "./local_bubble_panel.js?vue&type=script&lang=js"
export * from "./local_bubble_panel.js?vue&type=script&lang=js"

import "./local_bubble_panel.vue?vue&type=style&index=0&id=d5c59726&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__